// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ig-widget-container[data-v-c8ff0dc8]{height:96px}.ig-widget-image[data-v-c8ff0dc8]{width:131px;height:76px}.ig-widget-title[data-v-c8ff0dc8]{width:155px}@media (max-width:374px){.ig-widget-container[data-v-c8ff0dc8]{height:90px}.ig-widget-image[data-v-c8ff0dc8]{width:100px;height:58px;margin:0 8px}.ig-widget-title[data-v-c8ff0dc8]{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
